import { HTTPRequestMethods } from '@enums/network-request-enums';
import { formatSlugToTitleCase } from '@utils/stringFormatters';

const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

const searchCache = new Map<string, Promise<any>>();

export const searchService = {
  searchCars: async (query: string, cityName: string, forApp?: boolean): Promise<any> => {
    const cacheKey = `cars_${query}_${cityName}`;
    
    if (searchCache.has(cacheKey)) {
      return searchCache.get(cacheKey)!;
    }

    const apiPromise = (async () => {
      try {
        const cName = formatSlugToTitleCase(cityName);
        const url = `${baseURL}/rest/v1/search?query=${encodeURIComponent(query)}&cityName=${encodeURIComponent(cName)}${forApp ? '&source=app' : ''}`;
        
        const response = await fetch(url, {
          method: HTTPRequestMethods.GET,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if(!response.ok){
          console.error("Invalid cars search response status", response?.status);
          searchCache.delete(cacheKey);
          return [];
        }

        const data = await response.json();
        return data;
      } catch (error: any) {
        console.error("Error fetching cars search:", error.message);
        searchCache.delete(cacheKey);
        return [];
      }
    })();

    searchCache.set(cacheKey, apiPromise);

    return apiPromise;
  },

  searchBlogs: async (query: string): Promise<any> => {
    const cacheKey = `blogs_${query || 'all'}`;
    
    if (searchCache.has(cacheKey)) {
      return searchCache.get(cacheKey)!;
    }

    const apiPromise = (async () => {
      try {
        let url = `${baseURL}/rest/v1/search/articles`;
        
        if (query && query.trim()) {
          url += `?query=${encodeURIComponent(query)}`;
        }
        
        const response = await fetch(url, {
          method: HTTPRequestMethods.GET,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if(!response.ok){
          console.error("Invalid cars search response status", response?.status);
          searchCache.delete(cacheKey);
          return [];
        }

        const data = await response.json();
        return data;
      } catch (error: any) {
        console.error('Error searching blogs:', error.message);
        searchCache.delete(cacheKey);
        return [];
      }
    })();

    searchCache.set(cacheKey, apiPromise);

    return apiPromise;
  },

  clearCache: () => {
    searchCache.clear();
  },

  clearCacheEntry: (type: 'cars' | 'blogs', query: string, cityName?: string) => {
    if (type === 'cars' && cityName) {
      const cacheKey = `cars_${query}_${cityName}`;
      searchCache.delete(cacheKey);
    } else if (type === 'blogs') {
      const cacheKey = `blogs_${query || 'all'}`;
      searchCache.delete(cacheKey);
    }
  }
};

export const searchCars = searchService.searchCars;
export const searchBlogs = searchService.searchBlogs;

 
